// AREA_STATUS_NONE = 0
// AREA_STATUS_CREATED = 1
// AREA_STATUS_AVAILABLE = 2
// AREA_STATUS_DISABLED = 3
// AREA_STATUS_REMOVED = 4
const get_route_color_status = (status = 0) => {
	let desc = '';

	switch (parseInt(status)) {
		case 0:   desc = '';       break;
		case 1:   desc = 'blue';   break;
		case 2:   desc = 'green';  break;
		case 3:   desc = 'orange'; break;
		case 4:   desc = 'red';    break;
		default:  desc = '';       break;
	}

	return desc;
}

// LOAD_STATUS_NONE = 0
// LOAD_STATUS_CREATED = 1
// LOAD_STATUS_REVIEW = 2
// LOAD_STATUS_WAITING = 3
// LOAD_STATUS_PROCESSING = 4
// LOAD_STATUS_GOOD = 5
// LOAD_STATUS_INCOMPLETE = 6
// LOAD_STATUS_BAD = 7
// LOAD_STATUS_REMOVED = 8
// LOAD_STATUS_ERROR = 9
const get_load_status_color = (status = 0) => {
	let color = '';

	switch (parseInt(status)) {
		case 0:   color = '';           break;
		case 1:   color = 'geekblue';   break;
		case 2:   color = 'cyan';       break;
		case 3:   color = 'warning';    break;
		case 4:   color = 'processing'; break;
		case 5:   color = 'success';    break;
		case 6:   color = 'orange';     break;
		case 7:   color = 'volcano';    break;
		case 8:   color = 'red';        break;
		case 9:   color = 'error';      break;
		default:  color = '';           break;
	}

	return color;
}

// CYCLE_STATUS_NONE = 0
// CYCLE_STATUS_CREATED = 1
// CYCLE_STATUS_STARTING = 2
// CYCLE_STATUS_AVAILABLE = 3
// CYCLE_STATUS_WAITING = 4
// CYCLE_STATUS_COMPLETED = 5
// CYCLE_STATUS_REMOVED = 6
export const get_cycle_status_color = (status = 0) => {
	let color = '';

	switch (parseInt(status)) {
		case 0:   color = '';          break;
		case 1:   color = 'blue';      break;
		case 2:   color = 'warning';   break;
		case 3:   color = 'green';     break;
		case 4:   color = 'orange';    break;
		case 5:   color = 'purple';    break;
		case 6:   color = 'red';       break;
		default:  color = '';          break;
	}

	return color;
}

// LOAD_MOVEMENT_NONE = 0
// LOAD_MOVEMENT_NEW = 1          # Location is NEW to DB + added to route (no APPEND needed)
// LOAD_MOVEMENT_UPDATE = 2       # Location data updated (coords, name, etc) - stays in same route
// LOAD_MOVEMENT_APPEND = 3       # Existing location added to route (wasn't in ANY active route before)
// LOAD_MOVEMENT_CHANGE = 4       # Existing location moved from one active route to another
// LOAD_MOVEMENT_REMOVE = 5       # Existing location removed from active route (not moved to another)
const get_movement_type_color = (status = 0) => {
	switch (parseInt(status)) {
		case 0: return 'none';
		case 1: return 'green';
		case 2: return 'blue';
		case 3: return 'magenta';
		case 4: return 'orange';
		case 5: return 'red';
		default: return '';
	}
}

// LOAD_DISCARD_NONE = 0
// LOAD_DISCARD_RULES = 1         # Failed business rules validation
// LOAD_DISCARD_INACTIVE = 2      # Route not active
// LOAD_DISCARD_INVALID = 3       # Invalid/missing route code
// LOAD_DISCARD_VECTORIZED = 4    # Discarded by vectorized pre-filter
const get_discard_type_color = (status = 0) => {
	switch (parseInt(status)) {
		case 0: return 'none';
		case 1: return 'red';
		case 2: return 'volcano';
		case 3: return 'orange';
		case 4: return 'gold';
		default: return '';
	}
}

export { get_route_color_status, get_load_status_color, get_movement_type_color, get_discard_type_color };
